import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AlertService } from '../../../../../app/utils/alert.service';
import { DataPackLine } from '../../../../../app/models/dataPackLine.model';

/**
 * @version $Id: content.component.ts 79366 2018-02-17 00:40:37Z thiago.h.neri $
 */
@Component({
  selector: 'removeModal',
  templateUrl: './content.template.html'
})
export class RemoveLineModalComponent {

	@Input() line: DataPackLine;

  constructor(private activeModal: NgbActiveModal, private alertService: AlertService) {

  }

  private close() {
    this.activeModal.close();
  }

  private remove() {
    this.activeModal.close();
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/packages/removeLine/content.component.ts